import React from "react";
import { Navigate } from "react-router-dom";
import { useAtomValue } from "jotai";
import { userAtom } from "@/stores/authStore";
import { getDefaultPagePerRole } from "@/lib/roleBasedDefaultPage";

const HomePage: React.FC = () => {
  const user = useAtomValue(userAtom);

  return <Navigate to={getDefaultPagePerRole(user?.role)} replace />;
};

export default HomePage;
